export enum EBatchType {
  transaction = 'transaction',
  blankForm = 'blankForm',
}
export enum EBatchStatus {
  draft = 'draft',
  schedulingPending = 'schedulingPending',
  pending = 'pending',
  schedulingApprove = 'schedulingApprove',
  approved = 'approved',
}


